import React, { FC } from "react";
import { Header /*, Footer */ } from "../shell/components";

interface RootPageProps {
    header: string;
}

const RootPage: FC<RootPageProps> = (props) => {
    return (
        <>
            <Header activePage={props.header} />
            {props.children}
            {/* <Footer /> */}
        </>
    );
};

export default RootPage;
